import { useI18n } from "../../i18n/LanguageContext";
import { api } from "../../lib/api";
import { Download } from "lucide-react";

export default function SuperAdminExports() {
  const { t } = useI18n();
  const items = [
    { kind: "users", label: t("superadmin.exportUsers"), color: "#4361EE" },
    { kind: "enrollments", label: t("superadmin.exportEnrollments"), color: "#4CC9F0" },
    { kind: "orders", label: t("superadmin.exportOrders"), color: "#FFB703" },
    { kind: "certificates", label: t("superadmin.exportCerts"), color: "#F72585" },
    { kind: "login-events", label: t("superadmin.exportLogins"), color: "#7A67EE" },
  ];
  return (
    <div className="space-y-6" data-testid="sa-exports-page">
      <header>
        <div className="text-xs font-bold uppercase tracking-widest text-[#F72585]">{t("superadmin.title")}</div>
        <h1 className="text-3xl md:text-4xl font-black tracking-tight">{t("superadmin.exports")}</h1>
      </header>
      <div className="grid md:grid-cols-2 gap-4">
        {items.map((it) => (
          <a key={it.kind} href={api.saExportUrl(it.kind)} target="_blank" rel="noreferrer"
             className="rounded-2xl bg-white border border-black/5 p-5 shadow-[0_2px_0_rgba(0,0,0,0.04)] flex items-center justify-between hover:translate-y-[-1px] transition"
             data-testid={`sa-export-${it.kind}`}>
            <div>
              <div className="text-xs font-black uppercase tracking-widest" style={{ color: it.color }}>{it.kind}</div>
              <div className="font-bold text-lg mt-1">{it.label}</div>
            </div>
            <Download className="h-6 w-6" style={{ color: it.color }} />
          </a>
        ))}
      </div>
    </div>
  );
}
